import React from 'react';
import { User } from 'lucide-react';
import { cn } from '@/utils/cn';

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: number | 'sm' | 'default' | 'lg';
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = '',
  size = 'default',
  icon,
  children,
  className,
  style,
}) => {
  const sizeNum = typeof size === 'number' ? size : size === 'sm' ? 24 : size === 'lg' ? 40 : 32;

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-neutral-200 text-neutral-600 overflow-hidden shrink-0',
        className
      )}
      style={{ width: sizeNum, height: sizeNum, fontSize: sizeNum * 0.45, ...style }}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      ) : icon ? (
        icon
      ) : children ? (
        <span className="font-medium">{children}</span>
      ) : (
        <User className="w-1/2 h-1/2" />
      )}
    </div>
  );
};

export { Avatar };
